<template>
    <div>
        <v-list two-line class="product-list no-padding-top bg-color">
            <v-list-tile class="product-item margin-bottom-s padding-left-s padding-right-s component-bg-color cursor-pointer"
                         avatar v-for="product in products"
                         :key="product.code"
                         :id="'M_' + product.code"
                         @click="handleClickProduct(product)"
                         inactive
            >
                <v-list-tile-avatar>
                    <choose-product-svg v-if="product.errorCode === 0" class="product_icon"></choose-product-svg>
                    <choose-product-svg v-else class="product_icon product_icon_disabled"></choose-product-svg>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title class="font-weight-regular color-headings-text">{{ product.name }}</v-list-tile-title>
                    <v-list-tile-sub-title v-if="product.udi">{{ product.udi }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="!product.active" class="no-active-product">
                    <span v-if="product.errorCode === 12">{{text('api.error.product.activation.period.not.started', [product.dateArgument])}}</span>
                    <span v-if="product.errorCode === 13">{{text('api.error.product.activation.period.expired', [product.dateArgument])}}</span>
                    <span v-if="product.errorCode === 14">{{text('api.error.product.not.released', [product.dateArgument])}}</span>
                    <span v-if="product.errorCode === 15">{{text('api.error.product.activation.period.expired', [product.dateArgument])}}</span>

                </v-list-tile-action>
            </v-list-tile>
        </v-list>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import chooseProductSvg from "../svg/productList/chooseProduct";

    export default
    {
        name: 'ProductList',

        components: {
            chooseProductSvg
        },

        computed: mapGetters({
            products: 'ProductListStore/getProductList',
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
        }),

        methods: {
            // Component methods.
            handleClickProduct (product) {
                if(product.active) {
                    this.$emit('onClickProduct', product.code);
                }
            },
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .home-container.container.grid-list-xl {

        .body-home {

            margin-bottom: -60px;

            .product_icon {
                width: 30px;
            }
        }
    }

    .product-list {

        li, .product-item {
            border-radius: 5px;
        }
        .product-item:hover {
            border: 1px solid $color-brand-primary;
        }
    }

    .container.grid-list-xl .activate-product{

        button {
            text-transform: none;
            @include border-radius(4px);

        }
    }

    .btn-start-assessment {
        border-color: $color-element-outline;
    }

    .icon-start-assessment {
        font-size: 2.25rem ;
        // SMASSDEV - 1119
        // word-spacing: 0.16 * 2.25rem;
        // line-height: 1.5 * 2.25rem;
        // letter-spacing: 0.12 * 2.25rem;
    }

    .no-active-product span {
        position:  relative;
        top: 15px;
    }
</style>



// WEBPACK FOOTER //
// src/common/components/shared/ProductList.vue